import { Injectable, OnInit } from "@angular/core";
import { SoundEnum } from "src/app/enums/sound.enum";

@Injectable({
  providedIn: "root"
})
export class SoundService implements OnInit {
  sound: any = {
    beep: new Audio("assets/music/beep.wav")
  };

  constructor() {}

  ngOnInit() {
    this.sound.beep.loop = false;
  }

  play(name: SoundEnum) {
    switch (name) {
      case SoundEnum.beep:
        this.sound.beep.play();
        break;
    }
  }
}
